import Vue from 'vue';

import { loggedUser } from '../store/loggedUser';

export interface TabsOperationMethods {
	hasTabAccess(menuCode: string, tab: any): boolean
}

export const TabsOperationMixin = Vue.extend({
	methods: {
		hasTabAccess(menuCode: string, tab: any) {
			return this.loggedUser.UserTabs.find((menu: any) => menu.MenuCode === menuCode
			&& menu.TabCode.find((code: string) => code === (Array.isArray(tab.labelKey) ? tab.labelKey.join(', ') : tab.labelKey)));
		},
	},
});
